import React from 'react';
import GoogleMapReact from 'google-map-react';
import { Icon, Segment } from 'semantic-ui-react';

const Marker = () => (
  <Icon name='map marker alternate' size='big' color='red' />
);

const defaultProps = {
  geoLocation: {
    lat: 49.895077,
    lng: -97.138451,
  },
};

const GoogleMap = ({ geoLocation = defaultProps.geoLocation }) => {

  let newGeolocation
  if(geoLocation.Pc && geoLocation.Vc){
   newGeolocation = Object.assign({}, { lat: geoLocation.Pc, lng: geoLocation.Vc  })
  }


  return (
    <Segment attached='bottom' style={{ padding: 0 }}>
      <div style={{ height: '300px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_KEY }}
          defaultCenter={newGeolocation || geoLocation}
          defaultZoom={8}
        >
          <Marker lat={newGeolocation?.lat || geoLocation?.lat} lng={newGeolocation?.lng || geoLocation?.lng} />
        </GoogleMapReact>
      </div>
    </Segment>
  );
};
export default GoogleMap;
